import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaUser, FaIdBadge, FaEnvelope, FaPhone } from 'react-icons/fa';
import '../../css/JuanIS/JuanISFacultyProfile.css';
import { useNavigate } from 'react-router-dom';

function JuanISFacultyProfile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        setError(null);

        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('Not authenticated. Please log in again.');
          setLoading(false);
          navigate('/juan-is-login');
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/faculty/profile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && response.data.data) {
          setProfile(response.data.data);
        } else {
          setError('Invalid response format from server.');
        }
        setLoading(false);
      } catch (err) {
        console.error('Error fetching faculty profile:', err);
        if (err.response?.status === 401 || err.response?.status === 403) {
          setError('Session expired. Please log in again.');
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          navigate('/juan-is-login');
        } else if (err.response?.status === 404) {
          setError('Faculty profile not found. Please contact support.');
        } else if (err.response?.status === 500) {
          setError('Server error. Please try again later.');
        } else {
          setError('Failed to load profile. Please check your connection and try again.');
        }
        setLoading(false);
      }
    };

    fetchProfile();
  }, [navigate]);

  if (loading) {
    return (
      <div className="juanis-faculty-profile-loading">
        <div className="juanis-faculty-profile-loading-spinner"></div>
        <p>Loading profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="juanis-faculty-profile-error">
        <p>{error}</p>
        <button onClick={() => window.location.reload()} className="juanis-faculty-profile-retry-button">
          Try Again
        </button>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="juanis-faculty-profile-error">
        <p>No profile data available.</p>
      </div>
    );
  }

  return (
    <div className="juanis-faculty-profile-container">
      <div className="juanis-faculty-profile-header">
        <div className="juanis-faculty-profile-avatar-section">
          <div className="juanis-faculty-profile-large-avatar">
            <FaUser className="juanis-faculty-profile-avatar-icon" />
          </div>
          <h2>{profile.fullName}</h2>
        </div>
      </div>

      <div className="juanis-faculty-profile-content">
        <h2>Faculty Profile</h2>
        
        <div className="juanis-faculty-profile-info-grid">
          <div className="juanis-faculty-profile-info-item">
            <FaIdBadge className="juanis-faculty-profile-info-icon" />
            <div className="juanis-faculty-profile-info-content">
              <label>Employee ID</label>
              <span>{profile.employeeID || 'Not available'}</span>
            </div>
          </div>

          <div className="juanis-faculty-profile-info-item">
            <FaEnvelope className="juanis-faculty-profile-info-icon" />
            <div className="juanis-faculty-profile-info-content">
              <label>Email Address</label>
              <span>{profile.email || 'Not available'}</span>
            </div>
          </div>

          <div className="juanis-faculty-profile-info-item">
            <FaPhone className="juanis-faculty-profile-info-icon" />
            <div className="juanis-faculty-profile-info-content">
              <label>Mobile Number</label>
              <span>{profile.mobile || 'Not available'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JuanISFacultyProfile;